import { Pipe, PipeTransform } from '@angular/core';
import { IDataGrouped } from '@app/interfaces/idata-grouped';

@Pipe({
  name: 'filterCount'
})
export class FilterCountPipe implements PipeTransform {

  transform(items: Array<IDataGrouped>, dummyarg: number): Array<any> {

    if (!items) {
      return items;
    }

    return items
      .filter(item => item?.count > 0) // filter only count > 0
      .sort((a, b) => b.count - a.count); // sort by count desc
  }

}
